/**
 * Stripped-down HammerJS annotations to be used within Material, which are necessary,
 * because HammerJS is an optional dependency. For the full annotations see:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/hammerjs
 */

//# sourceMappingURL=gesture-annotations.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@angular/material/core/gestures/gesture-annotations.js
// module id = ./node_modules/@angular/material/core/gestures/gesture-annotations.js
// module chunks = vendor